<template lang="html">
  <v-layout ma-0>
    <v-text-field
      ref="input"
      v-model="internalValue"
      type="number"
      v-bind="$attrs"
      :label="internalLabel"
      :rules="internalRules"
      data-lpignore="true"
      autocomplete="off"
      :step="decimals ? 'any': ''"
      class="si-input-numberxxx hide-spinner si-align-input-icon"
      :hint="hint"
      v-on="listeners"
      @change="handleChange"
    >
      <template
        v-if="!hideSpinner"
        #append
      >
        <v-btn-toggle style="position: absolute; right: 8px; top: 14px">
          <v-btn
            text
            small
            icon
            color="primary"
            :disabled="atMin"
            @click="removeNumber"
          >
            <v-icon>remove</v-icon>
          </v-btn>
          <v-btn
            text
            small
            icon
            color="primary"
            :disabled="atMax"
            @click="addNumber"
          >
            <v-icon>add</v-icon>
          </v-btn>
        </v-btn-toggle>
      </template>
    </v-text-field>
  </v-layout>
</template>

<script>
import helpers from '@/mixins/helpers'
import element from '@/mixins/element'

export default {
  mixins: [ helpers, element ],
  props: {
    value: [Number, String],
    decimals: {
      type: [ Number, String ],
      default: 0
    },
    increment: [ Number, String ],
    hideSpinner: Boolean,
    max: [ Number, String ],
    min: [ Number, String ]
  },
  data () {
    return {
      lazyValue: this.value,
      externalChange: false,
      requiredRule: v => this.valueValid(v) || `${this.$attrs.label || 'This field'} is required`
    }
  },
  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.processNumber(val, 'input')

      }
    },
    listeners () {
      /*eslint-disable-next-line no-unused-vars */
      const { change, ...listeners } = this.$listeners
      return listeners
    },
    additionalRules () {
      let rules = []
      if (this.max !== undefined) rules.push(v => parseFloat(v, 10) <= this.max || `${this.$attrs.label} cannot be greater than ${this.max}`)
      if (this.min !== undefined) rules.push(v => parseFloat(v, 10) >= this.min || `${this.$attrs.label} cannot be less than ${this.min}`)
      return rules
    },
    atMin () {
      return this.min !== undefined ? this.internalValue <= this.min : false
    },
    atMax () {
      return this.max !== undefined ? this.internalValue >= this.max : false
    },
    hint () {
      let hasMin = this.min !== undefined
      let hasMax = this.max !== undefined
      return (hasMin || hasMax)
        ? `${hasMin ? 'Min: ' + this.min + ' ' : ''}${hasMax ? 'Max: ' + this.max : ''}`
        : null
    }
  },
  watch: {
    value (val) {
      let hasVal = val !== '' && val !== null && val !== undefined 
      if (hasVal && Number(this.internalValue || 0) !== Number(val)) {
        this.externalChange = true
        this.internalValue = val
        this.$nextTick(() => this.externalChange = false)
      }
    }
  },
  methods: {
    handleChange (val) {
      // if (this.$refs.input) this.$refs.input.internalValue = this.internalValue
      // this.$nextTick(() => { this.$emit('change', this.internalValue) })
      this.processNumber(val, 'change')
    },
    processNumber (val, eventType) {

      if ((val || val === 0) && this.decimals) {
        let stringVal = val.toString()
        let hasDecimal = stringVal.indexOf('.') > -1
        let parts = stringVal.split('.')
        let wholeNumbers = parts[0]
        let decimalNumbers = parts[1]
        if (decimalNumbers !== undefined && hasDecimal) {
          // check if whole nubmers is -0 as when it gets convereted to string it will come out as 0 which is incorrect if it is say -0.1
          val = `${wholeNumbers === '-0' ? wholeNumbers : Number(wholeNumbers || 0)}.${decimalNumbers.substring(0, this.decimals)}`
        } else if (hasDecimal) {
          val = `${Number(wholeNumbers || 0)}.`
        } else if (!decimalNumbers || decimalNumbers.length === 0) {
          val = Number(val)
        }
      }
      if (this.$refs.input && this.$refs.input.internalValue !== val) this.$refs.input.internalValue = val
      // let value = val || val === 0 ? Number(val) : val//isNaN(parseFloat(val, 10)) ? null : Number(parseFloat(val, 10).toFixed(Number(this.decimals)))
      this.lazyValue = this.externalChange && (val || val === 0 ) ? Number(val) : val

      this.$emit(eventType, Number(val))
    },
    newNumber (operator) {
      let { internalValue } = this
      let rounder = operator === 'add' ? 'floor' : 'ceil'
      let increment = Number(this.increment) || 1 /// Math.pow(10, Number(this.decimals))
      let decimals = (increment.toString().split('.')[1] || '').length
      let multiplier = Math.pow(10, Number(decimals))
      // let newNumber = Number(internalValue <= 1 ? internalValue : (Math[rounder]((parseFloat(internalValue || 0) + Number.EPSILON) * multiplier) / multiplier))
      let newNumber = Number(internalValue <= 1 ? internalValue : (Math[rounder]((parseFloat(internalValue || 0)) * multiplier) / multiplier))
      newNumber = operator === 'add' ? newNumber + increment : newNumber - increment
      return parseFloat(newNumber.toFixed(decimals))
    },
    addNumber () {
      let max = Number(this.max)
      let newNumber = this.newNumber('add')
      if (max) {
        this.internalValue = parseFloat(this.internalValue) >= max ? max : newNumber//: parseFloat(this.internalValue || 0) + increment
      } else {
        this.internalValue = newNumber//parseFloat(this.internalValue || 0) + increment
      }
      // this.$nextTick(() => { this.processNumber(this.internalValue, 'change') })
    },
    removeNumber () {
      let min = Number(this.min)
      let newNumber = this.newNumber('subtract')
      if (!this.internalValue && this.internalValue !== 0) {
        this.internalValue = this.min !== undefined ? Math.max(min, 0) : 0
      } else if (this.min !== undefined) {
        this.internalValue = parseFloat(this.internalValue) <= min ? min : newNumber // : parseFloat(this.internalValue) - increment
      } else {
        this.internalValue = newNumber // parseFloat(this.internalValue) - increment
      }
      // this.$nextTick(() => { this.processNumber(this.internalValue, 'change') })
    }
  }
}
</script>

<style lang="css" scoped>

</style>
